import Breadcrumb from '@carvana/ds-breadcrumb';
import { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import Actions, { ActionsLocations } from '@/vdp/Actions';
import ShowConditionally from '@/vdp/VehicleDetailsContainer/ShowConditionally';
import { SectionName } from '~/constants/vdp/section';
import { useIsMobile, useIsNative } from '~/context/common/DeviceContext';
import GlobalContext from '~/context/vdp/GlobalContext';
import { SectionAnalyticsProvider } from '~/context/vdp/SectionAnalyticsContext';
import { useParentModelBreadcrumbs } from '~/hooks/vdp';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import { Wrapper } from './BreadCrumbs.styles';

function BreadCrumbs() {
  const breadCrumbs = useParentModelBreadcrumbs();
  const isMobile = useIsMobile();
  const { setIsBreadcrumbScrolledOut } = useContext(GlobalContext);

  const [ref, inView] = useInView({
    threshold: [0, 1]
  });

  useEffect(() => {
    if (!isMobile) {
      setIsBreadcrumbScrolledOut(!inView);
    }
  }, [inView, isMobile, setIsBreadcrumbScrolledOut]);

  return (
    <div ref={ref}>
      <Breadcrumb
        backIcon={false}
        classes={{
          container: 'whitespace-pre',
          link: 'text-text-weak hover:text-text-weak'
        }}
        crumbs={breadCrumbs}
        size="sm"
      />
    </div>
  );
}

function BreadCrumbsWrapper() {
  const isNative = useIsNative();

  if (isNative) return null;

  return (
    <SectionAnalyticsProvider analyticsId={SectionName.Hero}>
      <Wrapper>
        <BreadCrumbs />
        <ShowConditionally native={false}>
          <Actions location={ActionsLocations.BreadCrumb} size="xxs" />
        </ShowConditionally>
      </Wrapper>
    </SectionAnalyticsProvider>
  );
}

export default withErrorBoundary(BreadCrumbsWrapper);
